import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  dialogContent: { padding: 0 },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: 4,
  },
  emptyMessage: {
    paddingX: 4,
    paddingTop: 3,
  },
  timeline: {
    paddingX: 4,
    paddingTop: 3,
    paddingBottom: 3,
    display: 'flex',
    flexDirection: 'column',
  },
  entryRow: {
    display: 'flex',
    gap: 1.5,
  },
  timelineColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
    width: 24,
  },
  timelineDot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    flexShrink: 0,
    marginTop: '5px',
  },
  timelineLine: {
    width: '2px',
    flex: 1,
    backgroundColor: 'gray.12',
    marginTop: '4px',
  },
  entryContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    paddingBottom: 5.5,
    flex: 1,
  },
  entryContentLast: {
    paddingBottom: 0,
  },
  entryNameRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexWrap: 'wrap',
  },
  bulletSeparator: {
    width: 4,
    height: 4,
    borderRadius: '50%',
    backgroundColor: 'gray.40',
    flexShrink: 0,
  },
  entryDateStr: { fontWeight: 600, fontSize: 14, lineHeight: '20px' },
  entryTimeStr: { fontWeight: 400, fontSize: 14, lineHeight: '20px' },
}
